// Native & external imports
import { Component, OnInit, inject } from "@angular/core";
// Services
import { LayoutService } from "src/services/layout.service";
import { CmpAppSettings } from "src/services/cmp-app-settings.service";

@Component({
  standalone: false,
  selector: "cmp-terms-and-condition",
  templateUrl: "./terms-and-condition.component.html",
})
export class TermsAndConditionComponent implements OnInit {
  private layoutService = inject(LayoutService);
  private cmpAppSettings = inject(CmpAppSettings);

  public companyName = "";
  public termsAndCondition: { [index: string]: string | boolean } = {};

  ngOnInit() {
    this.layoutService.termsAndCondition["loading"] = false;
    this.layoutService.containerClass = "container";
    this.companyName = this.cmpAppSettings.getAppSetting("companyName");
  }
}
